import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ViewTestimonialsDrawer from "./ViewTestimonialsDrawer";

const SelectPathway = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedPathway, setSelectedPathway] = useState(null);

  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };

  const pathwayOptions = [
    {
      id: "condition",
      title: "Eligibility check & Book online",
      description:
        "Check if you're eligible for medical cannabis & book an initial consultation with our clinician.",
      iconSrc: "/images/eligibility/note.svg",
    },
    {
      id: "callback",
      title: "Request a callback",
      description:
        "If you've got questions or need help booking your initial consultation, speak to us via call.",
      iconSrc: "/images/eligibility/call-request.svg",
    },
  ];

  const pathwayListItems = [
    "I’m aware about medical cannabis.",
    "I have been diagnosed with an eligible condition.",
    "I’m transferring from another medical cannabis clinic.",
    "I’m ready to book my initial consult.",
  ];

  const PathwayCard = ({ option }) => {
    const isSelected = selectedPathway === option.id;

  useEffect(() => {
    localStorage.setItem("baseUrl",window.location.href)
  }, [])

    return (
      <div
        className={`d-flex flex-column px-4 px-md-3 pb-4 pb-md-3 pt-3 pt-md-2 ${
          isSelected ? "pathway-card border-0" : "border card-border"
        } rounded cursor-pointer`}
        onClick={() => setSelectedPathway(option.id)} 
      >
        <img src={option.iconSrc} alt={option.title} className="pathway-icon" />
        <p className="fw-bold mb-1 mt-2">{option.title}</p>
        <p className="text-dark-6 flow-gap mb-0">{option.description}</p>
      </div>
    );
  };

  return (
    <div className="container h-100">
      <div className="column col-md-12 col-lg-12 col-xl-12 d-flex flex-column align-items-md-end justify-content-between h-100">
        <div className="row">
          <div className="col-md-12 col-lg-12 col-xl-9 px-0 py-0">
            <h4 className="mb-2 fw-bold">Select a pathway that suits you</h4>
            <p className="text-gray-1 mb-3">
              I’m ready to book an initial consult.
            </p>
            <ul className="select-pathway-list mb-6">
              {pathwayListItems.map((item, index) => (
                <li className="mb-1" key={index}>
                  {item}
                </li>
              ))}
            </ul>
            <div className="d-flex flex-column flex-lg-row gap-4 gap-lg-3 mb-5 mb-md-0">
              {pathwayOptions.map((option) => (
                <PathwayCard key={option.id} option={option} />
              ))}
            </div>
          </div>
        </div>
        <div className="column d-flex flex-row justify-content-center justify-content-md-end fixed-single-footer align-items-center">
          <div className="d-flex flex-column-reverse flex-md-row footer-div px-5 px-md-0 py-4 py-md-0">
            <button
              className="d-block d-md-none text-primary-600 bg-transparent pt-2 pb-0 px-4 w-100 w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
              type="button"
              onClick={toggleModal}
            >
              <p className="mb-0 fw-bold fs-6">
                View testimonials
              </p>
            </button>
            <button
              className="bg-primary-600 text-white py-2 px-5 w-100 w-md-fit h-fit fw-bold fs-6 border-0 rounded text-nowrap"
              type="button"
              onClick={() => {
                if (selectedPathway) {
                  navigate(`${selectedPathway}`);
                }
              }}
              disabled={!selectedPathway} 
            >
              Continue
            </button>
          </div>
        </div>
      </div>
      <ViewTestimonialsDrawer show={showModal} onClose={toggleModal} />
    </div>
  );
};

export default SelectPathway;
